import { RollLabel } from './styles'
import useTranslateMessage from '../../../hooks/useTranslateMessage'
import { useCallback, useEffect, useState } from 'react'

interface RollAnimationProps {
  items: {
    title: string
    gradient: string
  }[]
}

const RollAnimation = ({ items }: RollAnimationProps) => {
  const translate = useTranslateMessage()
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    setIsFirstRender(false)

    const interval = setInterval(() => {
      setIsAnimating(true)
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length)
      }, 500)
    }, 3000)

    return () => clearInterval(interval)
  }, [items.length])

  const onAnimationEnd = useCallback(() => setIsAnimating(false), [])

  return (
    <RollLabel
      data-testid="RollAnimation"
      gradient={items[currentIndex].gradient}
      isAnimating={!isFirstRender && isAnimating}
      onAnimationEnd={onAnimationEnd}
    >
      {translate(items[currentIndex].title)}
    </RollLabel>
  )
}

export default RollAnimation
